export default __webpack_public_path__ + "static/media/Bionic-Arm-06.088e2a55.jpg";